export const isEven = (row: number) => row % 2 === 0;
